// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"B1-z","subtitle":"C1-z","wrapper":"D1-z","leftArrow":"E1-z","rightArrow":"F1-z"};